import React from 'react';
import PropTypes from 'prop-types';
import NavPage from 'components/layout/NavPage';
import HeroCard from 'components/shared/HeroCard';

import './ErrorPage.scss';

class ErrorPage extends React.Component {
  static propTypes = {
    errorHeading: PropTypes.string,
    errorText: PropTypes.string,
  };

  render() {
    return (
      <NavPage>
        { /* TODO: https://issues.amazon.com/issues/AUTHOR-3962
         Do not pass in user input because of XSS risks with dangerouslySetInnerHTML */ }
        <HeroCard
          headingText={this.props.errorHeading}
          dangerouslySetBodyText={this.props.errorText}
        />
        <div className="aa-error-container">
          <div className="amazon-dog">
            <a href="https://www.amazon.com/p/feature/d8j6je99gnx65bk?ref_=doa_red" target="_blank">
              <img src={require('../assets/milly.jpg')} />
            </a>
          </div>
        </div>
      </NavPage>
    );
  }
}

export default ErrorPage;
